import React, {Component} from 'react'
import Validator from '../helpers/validate'
import Select from 'react-select'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import transformOptions from '../helpers/transformOptions'
import _ from "lodash"

class TrafficSources extends Component {

    constructor(props) {
        super(props)
        this.state = {
            valid:null,
            required:false,
            focused:false,
            hasError:null,
            message:'',
            value:''
        }

        //console.log(this.props)
        
        this.validator = new Validator
        if (_.includes(this.props.valid, "required")) {
			this.state.required = true
		}
    }

    static getDerivedStateFromProps(props, state) {
        if(props.value !== state && props.value) {
            state.value = props.value
            return state
        }
        return null
    }

    componentDidUpdate(prevProps, prevState) {
        // For editing screens
        if(prevProps.value !== prevState.value && this.props.editing) {
            this.validate(this.props.valid)
        }
    }

    validate(opts) {
        if(opts.length == 0) { return }
        var status = []
        var ret = true
        opts.map((r) => {
            status.push(this.validator[r](this.state.value))
        })
        status.map((r) => {
            if(r !== true) {
                this.setState({valid:false, hasError:true, message:r.message})
                this.props.setValid(this.props.id, false)
                ret = r
            }
        })
        if(ret === true) {
            this.setState({valid:true, hasError:false, message:''})
            this.props.setValid(this.props.id, true)
        }
        return ret
    }

    getValidationState = () => {
        if(this.state.valid === false) {
            return 'error'
        }
        else if(this.state.valid === true) {
            return 'success'
        }
        else {
            return null
        }
    }

    _handleChange = (v) => {
        // React-select sets the value to null if the clear 'X' is clicked
        if(v === null) {
            v = {
                value: ''
            }
        }
        
        this.setState({value:v.value}, () => {
            this.validate(this.props.valid)
        })
        this.props.updateValue(this.props.id, v.value, this.props.index)
    }

    _onBlur = () => {
        this.validate(this.props.valid)
    }
    
    render() {
        var req = (this.state.required) ? '*' : ''
        var classNames = require('classnames')
        var classes = classNames('form__fieldGroup',
            {
                'form__fieldGroup--active':this.state.focused,
                'form__fieldGroup--error': this.state.hasError,
                'form__fieldGroup--success': this.state.valid
            })
        return (
            <div className={classes}>
                <label htmlFor={this.props.id}>{this.props.label}<sup>{req}</sup></label>
                <div className="form__message">{this.state.message}</div>
                <Select
                    name={this.props.id}
                    ref={this.props.id}
                    value={this.state.value}
                    options={transformOptions(this.props.trafficSources)}
                    onChange={this._handleChange}
                    onBlur={this._onBlur}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        trafficSources:state.trafficSources
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch)
}


export default connect(mapStateToProps, matchDispatchToProps)(TrafficSources)
